<template>
<el-dialog
  :visible='true'
  title='发送确认'
  :before-close='handleClose'
  width='650px'
  :close-on-click-modal='false'
>
<div style="line-height: 30px;">
  <div>
    <span >
      发送人数：
      <span :style="{ color: globalBG }">{{mediaTestMobilesList.length}}</span>人</span>
  </div>
  <div>
    卡片短信内容：{{ title }}
  </div>
  <div>
    卡片短信计费条数：<span :style="{ color: globalBG }">1</span>条
  </div>
  <div>
    提交条数：<span :style="{ color: globalBG }">{{ mediaTestMobilesList.length }}</span>条
  </div>
</div>
<template #footer>
  <div class='dialog-bottom' >
    <el-button @click='handleClose' type='secondary' size='small'>取消</el-button>
    <el-button @click='handleConfirm' type='primary' size='small'>确定</el-button>
  </div>
</template>
</el-dialog>
</template>

<script>
import {
  testMedia
} from "@/api/smsSend";
export default {
 name: '' ,
 components: {},
 props:{
  
  id:{
    type: String | Number,
    default: "",
  },
  mediaTestMobilesList:{
    default: [],
  },
  source:{
    default: "",
  },
  title:{
    type: String | Number,
    default: "",
  },
  mediaTemplateId:{
    type: String | Number,
    default: "",
  }

 },
 data() {
  return {
    loading:false,
    globalBG:"#FE4D45",
  }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
    testMedia({
      mediaTemplateId:this.mediaTemplateId,
      mediaTestMobiles:this.mediaTestMobilesList.join(','),
      source:this.source,
      type:1,
    }).then(res=>{
      if(res.code == 1){
        this.$emit('confirm');
        this.$message.success('已提交发送！');
      }else{
        this.$message.error(res.message);
      }
    })
  },
  
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}
</style>